import React, { useEffect, useState } from "react";
import { homeUrl } from "../../constant";
import {
  useNavigate,
  useLocation,
  createSearchParams,
} from "react-router-dom";
import Loader from "../../components/Loader";
import Form from "../../components/Form";
import "../../pages/paymentPage.css";
import { useGlobalState } from "../../globalStyle";
import DataServices from "../../components/DataServices";
import { set } from "react-hook-form";

const Paytm = ({ formattype }) => {
  const leadBody = useGlobalState("leadSquaredDataVal")[0];
  const authorizereqUrl = useGlobalState("AUTHORIZEREQURL")[0];
  const verifyUrl = useGlobalState("VERIFYUSERS")[0];
  const search = useLocation().search;
 
  const initialState = {
    clientCode: "",
    mobile: "",
    client_email: "",
    product_plan_id: "",
    gst: "",
    first_name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    formattype: formattype,
    ...leadBody,
    return_url: `${homeUrl}/payment/${paymentMethod}/paytm?formattype=${formattype}`,
  };

  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isLogoDisplay, setIsLogoDisplay] = useState(false);
  const [reqParams, setReqParams] = useState(initialState);
  const [familyUser,setFamilyUser] = useState(null);
  const params = new URLSearchParams(search);
  var paymentMethod = params.get("paymentMethod");

  let gst = "";
  let urlProductPlanId = params.get("product_plan_id") || params.get("planCode");
  let urlClientCode = params.get("clientCode");
  let urlMobile = params.get("mobile");
  let urlClientEmail = params.get("client_email") || params.get("mailId");
  let urlFirstName = params.get("first_name");
  let urlAddress = params.get("address");
  let urlCity = params.get("city");
  let urlPincode = params.get("pincode");
  var logo = params.get("logo");
  // console.log("form data : ",product_plan_id,clientCode,mobile,client_email,first_name)

  if (!urlClientCode || urlClientCode === "%22null%22" || urlClientCode === "null") {
    urlClientCode = urlMobile;
  }

  useEffect(() => {
    setIsLogoDisplay(logo);
  }, [isLogoDisplay, logo]);

  useEffect(() => {
    setReqParams({
      ...reqParams,
      clientCode: urlClientCode,
      mobile: urlMobile,
      client_email: urlClientEmail,
      gst: gst,
      product_plan_id: urlProductPlanId,
      first_name: urlFirstName,
      address: urlAddress,
      city: urlCity,
      pincode: urlPincode,
      state: "",
      formattype: formattype,
      return_url: initialState.return_url,
    });
  }, [urlClientCode, urlMobile, urlClientEmail, gst, urlProductPlanId, urlFirstName, urlAddress, urlCity, urlPincode, formattype, initialState.return_url]);

  const fetchFamilyUserStatus = async () => {
    setLoader(true)
    if (urlMobile) {
      // Check clientCode conditions
      if (urlClientCode && (urlClientCode !== urlMobile || urlClientCode.length !== 10)) {
        setFamilyUser(false);
      } else {
        // Only check family user status if clientCode is valid
        const familyUserResult = await DataServices.isFamilyUser(urlMobile,authorizereqUrl,verifyUrl);
        setFamilyUser(familyUserResult.family);
        setReqParams((prevParams) => ({
          ...prevParams,
          clientCode: familyUserResult.clientCode,
        }));
      }
      // setLoader(false);
    } else {
      setFamilyUser(false); // Default to false if mobile number is not present
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchFamilyUserStatus();
  }, [urlMobile, urlClientCode]);

  // When all form data is available then its directily checkout Paytm
  const redirectTonext = async () => {
    setLoader(true);
    const { client_email, mobile, product_plan_id, clientCode } = reqParams;
    if (client_email && product_plan_id && mobile) {
      const req = {
        product_plan_id: reqParams.product_plan_id || "",
        client_email: reqParams.client_email || "",
        mobile: reqParams.mobile || "",
        clientCode: reqParams.clientCode || "",
        gst: gst || "",
        first_name: reqParams.first_name || "",
        address: reqParams.address || "",
        city: reqParams.city || "",
        pincode: reqParams.pincode || "",
        state: reqParams.state || "",
        formattype: formattype,
        return_url: `${homeUrl}/payment/${paymentMethod}/paytm?formattype=${formattype}`,
      };

      navigate({
        pathname: "/details",
        search: `?${createSearchParams({
          ...req,
          paymentMethod: paymentMethod,
          paymentGateway: "paytm",
          ...leadBody,
        })}`,
      });
    } else {
      setLoader(false);
    }
  };

  // handle redirection based on familyUser status
  useEffect(() => {
    if (familyUser === false) {
      redirectTonext();
    }
  }, [familyUser, loader]);

  return (
    <div className="paytm-wrapper">
      {loader ? (
        <div className="loader">
          <Loader message="please wait.. " />
        </div>
      ) : (
        <div>
          <Form data={reqParams} />
        </div>
      )}
    </div>
  );
};

export default Paytm;
